import { IStore } from "../store";

export const loadingMovErrorSelector = (state: IStore) => state.engine.loadingMovError;
export const loadingMovVivErrorSelector = (state: IStore) => state.engine.loadingMovVivError;
export const loadingMovVivLavErrorSelector = (state: IStore) => state.engine.loadingMovVivLavError;
export const tariffeMultipleSelector = (state: IStore) => state.engine.tariffeMultiple;
export const stepSelector = (state: IStore) => state.engine.step;
export const selectionsSelector = (state: IStore) => state.engine.selections;
export const completeMovSelector = (state: IStore) => state.engine.completeMov;
export const completeMovVivSelector = (state: IStore) => state.engine.completeMovViv;
export const completeMovVivLavSelector = (state: IStore) => state.engine.completeMovVivLav;
export const prevStepsSelector = (state: IStore) => state.engine.prevSteps;
